import fetch from './toFetch';

export default {
  /**
   * 提交答题
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  submit({
    sid,
    answers,
    starttime,
    clientinfo,
    reply_status = 0
  }) {
    return fetch('/f/user/reply', {
      sid,
      answers,
      starttime,
      clientinfo,
      reply_status
    })
  },

  getFakeToken({
    account,
    project,
    nickname
  }) {
    return fetch('/f/user/gamelogintoken', {
      account,
      project,
      nickname
    })
  },

  logout(sid) {
    return fetch('/f/user/logout', {
      sid
    })
  },

  login(data) {
    return fetch('/f/user/login', data)
  },

  /**
   * 提交答题
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  getInfo(sid) {
    return fetch(`/f/survey/fview?sid=${sid}`, {}, {
      type: 'GET'
    });
  },
}
